import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../../../../../components/Typography';
import { i18nNS } from '../../../../../../../i18n';
import { Overlay } from '../styles';
import { HideResultsIcon } from './styles';
import useManualPollOverlay from './vm';

const ManualPollOverlay = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { canSeeOverlay } = useManualPollOverlay();

  if (!canSeeOverlay) return null;

  return (
    <Overlay>
      <Stack alignItems="center" gap={2}>
        <HideResultsIcon />
        <Typography variant="h4Bold" color="common.black" textAlign="center">
          {t('results_will_be_visible_once_the_instructor_closes_the_poll', { ns: i18nNS.POLL })}
        </Typography>
      </Stack>
    </Overlay>
  );
};

export default ManualPollOverlay;
